// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"2195":"EditWaypointSidebar","3176":"FolderDetailsSidebar","3554":"TrackDetailsSidebar","5545":"SavedItemsSidebar","6620":"WaypointDetailsSidebar"}[chunkId] + "." + {"2195":"1a9d7050","3176":"14b11ce5","3554":"04cc6495","5545":"1a9d7050","6620":"04cc6495"}[chunkId] + ".chunk.css";
};